import jQuery from 'jquery';

/**
 * @class GoogleDirectionsHelper
 * @classdesc Service to calculate the journeys
 */
export default class GoogleDirectionsHelper {

  static _createService() {
    this.service = new google.maps.DirectionsService();
    return this.service;
  }

  /**
   * Returns a journey from Google directions API.
   * @param {string} from - The origin address to calculate the journey.
   * @param {string} to - The destination address to calculate the journey.
   * @param {object} options - Extra parameters to calculate the journey.
   * @returns The promise to handler the result.
   */
  static getJourney(from, to, options) {
    let deferred = jQuery.Deferred();
    let service = this.service || this._createService();
    let directionsRequest = this._setRequest(from, to, options);
    service.route(directionsRequest, function(result, status) {
      deferred.resolve(result);
    });

    return deferred.promise();
  }

  //Create the directions request
  static _setRequest(from, to, options) {
    var TRAVELMODE = {
        transit: google.maps.TravelMode.TRANSIT,
        driving: google.maps.TravelMode.DRIVING,
        walking: google.maps.TravelMode.WALKING,
        bicycling: google.maps.TravelMode.BICYCLING
      },
      TRANSITMODE = {
        bus: google.maps.TransitMode.BUS,
        rail: google.maps.TransitMode.RAIL,
        subway: google.maps.TransitMode.SUBWAY,
        train: google.maps.TransitMode.TRAIN,
        tram: google.maps.TransitMode.TRAM
      },
      ROUTINGPREFERENCE = {
        lesswalking: google.maps.TransitRoutePreference.LESS_WALKING,
        fewertransfers: google.maps.TransitRoutePreference.FEWER_TRANSFERS
      },
      TRAFFICMODEL = {
        pessimistic: google.maps.TrafficModel.PESSIMISTIC,
        bestguess: google.maps.TrafficModel.BEST_GUESS,
        optimistic: google.maps.TrafficModel.OPTIMISTIC
      },
      directionsRequest = {
        origin: null,
        destination: null,
        waypoints: null,
        travelMode: null,
        avoidHighways: null,
        avoidTolls: null
      },
      transitOptions = {
        modes: []
      },
      i, j, mode, preference;
    if (!!from && !!to) {
      directionsRequest.origin = from.marker ? from.marker.getPosition() : from.value;
      directionsRequest.destination = to.marker ? to.marker.getPosition() : to.value;
      directionsRequest.travelMode = options && options.travelMode ?
        TRAVELMODE[options.travelMode] : TRAVELMODE.transit;
      directionsRequest.provideRouteAlternatives = true;
      directionsRequest.region = options && options.region ?
        options.region : 'uk';
      directionsRequest.avoidTolls = options && options.avoidTolls ? options.avoidTolls : false;
      directionsRequest.avoidHighways = options && options.avoidHighways ? options.avoidHighways : false;
    }
    // Optional parameters
    if (options) {
      if (options.waypoints) {
        directionsRequest.waypoints = options.waypoints;
      }
      if (options.departureTime) {
        transitOptions.departureTime = options.departureTime;
      }
      if (options.arrivalTime) {
        transitOptions.arrivalTime = options.arrivalTime;
      }
      if (options.modes) {
        for (i = 0; i < options.modes.length; i++) {
          mode = options.modes[i].toLowerCase();
          transitOptions.modes.push(TRANSITMODE[mode]);
        }
      }
      if (options.routingPreference) {
        for (j = 0; j < options.routingPreference.length; j++) {
          preference = options.routingPreference[j].toLowerCase();
          transitOptions.routingPreference = ROUTINGPREFERENCE[preference];
        }
      }
      if (options.unitSystem) {
        directionsRequest.unitSystem = options.unitSystem.toUpperCase() === 'METRIC' ? google.maps.UnitSystem.METRIC :
          google.maps.UnitSystem.IMPERIAL;
      }
      if (options.drivingOptions) {
        directionsRequest.drivingOptions = {
          departureTime: options.drivingOptions.departureTime ? options.drivingOptions.departureTime : new Date(),
          trafficModel: TRAFFICMODEL[options.drivingOptions.trafficModel]
        };
      }
    }
    directionsRequest.transitOptions = transitOptions;
    return directionsRequest;
  }
}



// WEBPACK FOOTER //
// ./lmm-widget/src/helpers/GoogleDirectionsHelper.js